// extracted by mini-css-extract-plugin
module.exports = {"flats":"_02712f2b3b--flats--yE7hv","flats-inner":"_02712f2b3b--flats-inner--ZnGfY"};